import { BriefcaseBusiness, Compass, ShoppingBag } from "lucide-react";
import type { ProductId } from "./products";

export const productIcons: Record<ProductId, typeof Compass> = {
  services: Compass,
  business: BriefcaseBusiness,
  deals: ShoppingBag,
};
